import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { analytics } from "../../analytics/analytics";
import { Button, PageHeader, Tag } from "../../components/ui";
export function ReviewPage() {
  const nav = useNavigate();
  const { venueRequestId } = useParams();
  const [rating, setRating] = useState(0);
  const [done, setDone] = useState(false);
  if (done)
    return (
      <div className="page">
        <PageHeader title="Thanks for sharing" />
        <p>
          Your review is pending moderation. Editing follows the rules supplied
          by the venue review API.
        </p>
        <Tag tone="warning">Pending</Tag>
      </div>
    );
  return (
    <div className="page">
      <PageHeader
        back={() => nav(-1)}
        eyebrow="POST-VISIT"
        title="Review Liza"
      />
      <p>This review is for this venue booking only, not the whole plan.</p>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          analytics.track("review_submitted", {
            venueRequestId: venueRequestId ?? "",
          });
          setDone(true);
        }}
      >
        <fieldset>
          <legend>Your rating</legend>
          <div className="stars">
            {[1, 2, 3, 4, 5].map((v) => (
              <button
                type="button"
                onClick={() => setRating(v)}
                aria-label={`${v} stars`}
                aria-pressed={rating === v}
                key={v}
              >
                {v <= rating ? "★" : "☆"}
              </button>
            ))}
          </div>
        </fieldset>
        <label>
          Title
          <input maxLength={80} required />
        </label>
        <label>
          Your experience
          <textarea maxLength={1000} rows={6} required />
        </label>
        <Button type="submit" disabled={!rating}>
          Submit review
        </Button>
      </form>
    </div>
  );
}
